import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RegistrationUserFurtherDataComponent } from './registration-user-further-data/registration-user-further-data.component';
import { TranslocoModule } from '@jsverse/transloco';
import { MarkantElementsModule } from '@markant/elements-angular';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterLink } from '@angular/router';
import { SharedLanguageSelectionFeatureModule } from '@markant-platform/shared/language-selection/feature';
import { RegistrationOrganizationSpecificDataComponent } from './registration-organization-specfic-data/registration-organization-specific-data.component';
import { ModalBridgeComponent } from '@markant-platform/shared/ui-modal';
import { UserConsentConfirmationComponent } from './user-consent-confirmation/user-consent-confirmation.component';
import { UiCountrySelectComponent } from '@markant-platform/shared/ui-components';
import {
  ArrayIncludesPipe,
  FormControlErrorPipe,
  FormControlKeyErrorPipe,
  TypeCastPipe,
} from '@markant-platform/shared/util-pipes';

@NgModule({
  imports: [
    CommonModule,
    TranslocoModule,
    MarkantElementsModule,
    FormsModule,
    ReactiveFormsModule,
    SharedLanguageSelectionFeatureModule,
    RouterLink,
    ModalBridgeComponent,
    TypeCastPipe,
    FormControlKeyErrorPipe,
    FormControlErrorPipe,
    ArrayIncludesPipe,
    UiCountrySelectComponent,
  ],
  exports: [
    RegistrationUserFurtherDataComponent,
    RegistrationOrganizationSpecificDataComponent,
    UserConsentConfirmationComponent,
  ],
  declarations: [
    RegistrationUserFurtherDataComponent,
    RegistrationOrganizationSpecificDataComponent,
    UserConsentConfirmationComponent,
  ],
})
export class SharedRegistrationModule {}
